import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { RoleDAO } from '../../../../core/services/dao/roleDAO';
import { AuthService } from '../../../../core/services/auth.service';
import { PermissionDAO } from '../../../../core/services/dao/permissionDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class RoleResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private roleDAO: RoleDAO,
    private permissionDAO: PermissionDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    let sessionResolve = this.authService.checkSession();
    let roleResolve = this.roleDAO.load();
    let permissionResolve = this.permissionDAO.load();

    const mergeResolve = merge(sessionResolve, roleResolve, permissionResolve);
    return mergeResolve.pipe(
      take(3),
      map((data) => data),
    );
  }
}
